import { Checkbox } from "primereact/checkbox";
import PropTypes from "prop-types";

const IconCheckBox = ({
  input,
  checkedIcon = "pi-check-circle",
  unCheckIcon = "pi-circle",
  meta,
  disabled = false,
}) => {
  const { checked, onChange } = input;

  return (
    <div
      className={`edexlms-icon-checkbox-container ${
        checked ? "checked" : "unchecked"
      }`}
      onClick={() => (!disabled && onChange(!checked)) || null}
      style={{ cursor: "pointer" }}
    >
      <Checkbox
        inputId={`icon-checkbox-${input.name}`}
        checked={checked}
        onChange={(e) => (!disabled && onChange(!checked)) || null}
        style={{ display: "none" }} // Hide the actual checkbox
      />

      <i className={`pi ${checked ? checkedIcon : unCheckIcon}`}></i>

      {meta.error && meta.touched && (
        <span className="p-error">{meta.error}</span>
      )}
    </div>
  );
};

IconCheckBox.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object,
  checkedIcon: PropTypes.string,
  unCheckIcon: PropTypes.string,
};

export default IconCheckBox;
